import { render, staticRenderFns } from "./BuyOrderLog.vue?vue&type=template&id=6e0eec60&"
import script from "./BuyOrderLog.vue?vue&type=script&lang=js&"
export * from "./BuyOrderLog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports